import dynamic from 'next/dynamic';
import Head from 'next/head';

import { pageTitle } from '../../components/shared/basic/customHead';
const ChatBox = dynamic(() => import('../../components/ChatBox'));

const BroadcastMessagePage = () => {
  return (
    <div>
      <Head>
        <title>{pageTitle('Broadcast-Message')}</title>
      </Head>
      <div className='fixed w-full '>
        <div
          className='max-h-[95%] flex pb-20 overflow-hidden w-full'
          style={{ overflowY: 'hidden' }}
        >
          <ChatBox />
        </div>
      </div>
    </div>
  );
};

export default BroadcastMessagePage;
